import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Input,
} from '@angular/core';
import { FeatureFlagService } from '../../shared/misc-services/feature-flag.service';

@Component({
  selector: 'h3-sampling-workspace-navbar',
  templateUrl: './sampling-workspace-navbar.component.html',
  styleUrls: ['./sampling-workspace-navbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SamplingWorkspaceNavbarComponent {
  @Input({ required: true }) isSaving!: boolean;
  enableNewSamplingNav = inject(FeatureFlagService).hasFlag('new-sampling-nav');
}
